/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_Analysis_TextInputs */

const en_gc_story_analysis_text = /** @type {(inputs: Gc_Story_Analysis_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A useful spreadsheet makes a pattern easier to see. Keep one kind of record per row, use clear column headings and give dates and amounts consistent formats. Then explore a chart for a quick comparison, or a PivotTable to group repeated categories. GridCraft’s sample sales workbook shows how tables and charts can share the same source data. For a budget, compare planned and actual spending; for a gradebook, inspect averages before assigning labels. Begin with a simple question, keep the underlying values visible and verify that a summary includes the intended rows.`)
};

const zh_gc_story_analysis_text = /** @type {(inputs: Gc_Story_Analysis_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实用的电子表格让规律更容易被看见。每行保留一种记录，使用清晰表头，并统一日期和金额格式。随后可以用图表进行快速比较，或用数据透视表汇总重复分类。GridCraft 销售示例展示了表格与图表共享来源数据的方式。预算表可比较计划与实际开支，成绩表可先检查平均分。始终从一个简单问题开始，并核对汇总包含了预期行。`)
};

/**
* | output |
* | --- |
* | "A useful spreadsheet makes a pattern easier to see. Keep one kind of record per row, use clear column headings and give dates and amounts consistent formats...." |
*
* @param {Gc_Story_Analysis_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_analysis_text = /** @type {((inputs?: Gc_Story_Analysis_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_Analysis_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_analysis_text(inputs)
	return zh_gc_story_analysis_text(inputs)
});
export { gc_story_analysis_text as "gc.story.analysis.text" }